"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.753 9.43988L10.753 2.35288C10.355 1.88188 9.646 1.88188 9.247 2.35288L3.247 9.43988C3.088 9.62788 3 9.86988 3 10.1209V17.4829C3 17.7689 3.224 18.0009 3.5 18.0009H7.5C7.776 18.0009 8 17.7689 8 17.4829V15.0099C8 13.9799 8.681 13.0259 9.664 12.8609C10.917 12.6499 12 13.6439 12 14.8999V17.4829C12 17.7689 12.224 18.0009 12.5 18.0009H16.5C16.776 18.0009 17 17.7689 17 17.4829V10.1209C17 9.86988 16.912 9.62788 16.753 9.43988Z",
    fill: "#727B7F"
  }));
};